import { render, staticRenderFns } from "./ModalUpdateActive.vue?vue&type=template&id=1edb9a4a&"
import script from "./ModalUpdateActive.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdateActive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports